// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__2B73J","item":"List_item__1Xj4R","name":"List_name__pSjmf","drafts":"List_drafts__1XCHu"};